module.exports = __webpack_public_path__ + "img/plane.53b971a3.png";